export default "__VITE_ASSET__BU091ijR__"